import { render, staticRenderFns } from "./OrganizationEditEventPage.vue?vue&type=template&id=30996ee2&"
import script from "./OrganizationEditEventPage.vue?vue&type=script&lang=js&"
export * from "./OrganizationEditEventPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports